// Decodes a VIN using the free NHTSA vPIC API (no API key required).
// Docs: https://vpic.nhtsa.dot.gov/api/  ·  DecodeVinValues returns one flat result row.

function titleCase(s) {
  return (s || '').toString().trim().toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
}

// VIN charset excludes I, O, Q. Pull the first valid 17-char run out of any text.
export function extractVin(text) {
  if (!text) return null;
  const cleaned = text.toUpperCase().replace(/[^A-HJ-NPR-Z0-9]/g, '');
  const m = cleaned.match(/[A-HJ-NPR-Z0-9]{17}/);
  return m ? m[0] : null;
}

// Returns { year, make, model, car } — `car` is the combined "YEAR Make Model" string.
// Throws if the network request fails.
export async function decodeVin(vin) {
  const clean = (vin || '').trim().toUpperCase();
  const url = `https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVinValues/${encodeURIComponent(clean)}?format=json`;
  const res = await fetch(url);
  if (!res.ok) throw new Error(`NHTSA lookup failed (${res.status})`);
  const data = await res.json();
  const r = (data.Results && data.Results[0]) || {};
  const year = (r.ModelYear || '').toString().trim();
  const make = titleCase(r.Make || '');
  const model = (r.Model || '').toString().trim();
  const car = [year, make, model].filter(Boolean).join(' ');
  return { year, make, model, car };
}
